import serviceTypeCodes from 'constants/serviceTypeCodes';

export const isJourneyDirectEROnly = ({ journeys }) => {
  if (journeys.length === 0) return false;
  return journeys.every(({ fares }) => {
    if (fares?.length === 0) return false;
    return fares?.[0]?.legs.length === 1 && fares?.[0]?.legs?.every(({ serviceType }) => serviceType.code === serviceTypeCodes.GREENSPEED);
  });
};
